export const enum ViewState {
    SCREENING_PAGE = 'Screening Page',
    INFO_MEETING_BOOK_PAGE = 'InfoMeeting Book Page',
    V0_MEETING_BOOK_PAGE = 'V0 Meeting Book Page',
    V1_MEETING_BOOK_PAGE = 'V1 Meeting Book Page',
    V3_MEETING_BOOK_PAGE = 'V3 Meeting Book Page',
    DENY_ACCESS_1 = 'Deny access 1',
    DENY_ACCESS_2 = 'Deny access 2',
    DENY_ACCESS_3 = 'Deny access 3',
    DENY_ACCESS_4 = 'Deny access 4',
    DENY_ACCESS_5 = 'Deny access 5',
    ACCESS_TO_DASHBOARD = 'Access to DashBoard 1',
    SERVER_ERROR = 'Server error',
}